import { DotMenuIcon, DotMenuToggle } from '../../../components/DotMenu';

// tslint:disable-next-line:variable-name
export const MenuIcon = DotMenuIcon;
export default DotMenuToggle;
